export const environment = {
  production: true,
  buildId: '3673682012723071',
  configFile: 'config.json',
};
